
import { parseAuthErrorFromHash } from './auth-error-utils'

/**
 * Pre-router error handler that intercepts error parameters before React Router processes them.
 * This must be called before the router is initialized.
 */
export function handlePreRouterErrors(): { hasError: boolean; errorData?: any } {
  const currentUrl = window.location.href
  const currentHash = window.location.hash

  console.log('[PreRouterErrorHandler] Checking for errors before router initialization')
  console.log('[PreRouterErrorHandler] Current URL:', currentUrl)
  console.log('[PreRouterErrorHandler] Current hash:', currentHash)

  // Check if error was already intercepted by the early interceptor
  if (sessionStorage.getItem('interceptedAuthError')) {
    console.log('[PreRouterErrorHandler] Error already intercepted by early interceptor, skipping')
    return { hasError: true }
  }

  // Check if we have error parameters in the hash
  if (currentHash.includes('error=') || currentUrl.includes('error=')) {
    console.log('[PreRouterErrorHandler] Found error parameters, storing for later processing')

    // Parse the error from the current hash
    const errorData = parseAuthErrorFromHash(currentHash)

    if (errorData) {
      console.log('[PreRouterErrorHandler] Successfully parsed error data:', errorData)

      // Store the error data in sessionStorage so we can retrieve it later
      sessionStorage.setItem('authError', JSON.stringify(errorData))

      // Clear the hash to prevent router confusion, but replace with error route
      const newUrl = window.location.origin + window.location.pathname + '#/auth/error'
      console.log('[PreRouterErrorHandler] Redirecting to:', newUrl)

      // Replace the current URL to trigger the error route
      window.history.replaceState(null, document.title, newUrl)

      return { hasError: true, errorData }
    }
  }

  return { hasError: false }
}

/**
 * Retrieve stored error data from sessionStorage and clear it
 */
export function getStoredErrorData(): any | null {
  const stored = sessionStorage.getItem('authError')
  if (stored) {
    console.log('[PreRouterErrorHandler] Retrieved stored error data:', stored)
    sessionStorage.removeItem('authError')
    return JSON.parse(stored)
  }
  return null
}
